























import { namespace } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { ConfigService } from '@/services/ConfigService';
import { CustomersApi, DeliveryAddressDto } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import SelectItem from '@/common/SelectItem';
import { CommonOrderDetailService } from '@/services/order/CommonOrderDetailService';
import CustomSelect from '@/common/CustomSelect.vue';

const cart = namespace(CART);

@Component({
  components: {CustomSelect}
})
export default class AddressAndUnloadingAreaRow extends Vue {
  public addresses: DeliveryAddressDto[] = [];
  public deliveryAddresses: SelectItem[] = [];
  public addressIndex = 0;
  public unloadAreas: string[] = [];
  public unloadAreaItems: SelectItem[] = [];
  public unloadIndex = 0;

  private orderDetailService = CommonOrderDetailService.singleton();

  public mounted() {
    const api = ApiService.wrap(CustomersApi);
    api.getDeliveryAddresses(ConfigService.getTenant(), ConfigService.currentCustomerId).then((result) => {
      this.addresses = result;
      for (const address of this.addresses) {
        const deliveryAddress = new SelectItem(
            address.externalId,
            this.extractAddressParts(address),
            address
        );
        this.deliveryAddresses.push(deliveryAddress);
      }
    }).catch(ApiService.defaultErrorHandler);
  }

  @Watch('currentAddress')
  public onAddressChange() {
    const addressDto: DeliveryAddressDto = this.deliveryAddresses.find((value) => {
      return value.key === this.currentAddress.key;
    }).obj;

    this.orderDetailService.saveDeliveryAddress(addressDto);
  }

  @Watch('currentUnloadArea')
  public onUnloadAreaChange() {
    if (this.currentUnloadArea) {
      this.orderDetailService.saveUnloadingArea(this.currentUnloadArea.key);
    } else {
      this.orderDetailService.saveUnloadingArea(null);
    }
  }

  get unloadingAreas() {
    this.unloadAreas = [];
    if (this.addresses != null && this.addresses[this.addressIndex] != null) {
      this.unloadAreas = this.addresses[this.addressIndex].unloadingAreas;
    }
    this.unloadAreaItems = this.unloadAreas.map((element) => {
      return new SelectItem(element);
    });
    return this.unloadAreas;
  }

  get currentUnloadArea() {
    return this.unloadAreaItems[this.unloadIndex];
  }

  set currentUnloadArea(unloadArea) {
    this.unloadIndex = this.unloadAreaItems.indexOf(unloadArea);
  }

  get currentAddress() {
    return this.deliveryAddresses[this.addressIndex];
  }

  set currentAddress(address) {
    this.addressIndex = this.deliveryAddresses.indexOf(address);
    this.unloadIndex = 0;
  }

  public extractAddressParts(deliveryAddress: DeliveryAddressDto): string[] {
    const addressParts: string[] = deliveryAddress.companyLines;
    let postCodeCity = '';
    if (deliveryAddress.postCode !== '') {
      postCodeCity = deliveryAddress.postCode + ' ' + deliveryAddress.city;
    } else {
      postCodeCity = deliveryAddress.city;
    }
    if (deliveryAddress.street !== '') {
      if (postCodeCity !== '') {
        postCodeCity += ', ' + deliveryAddress.street;
      } else {
        postCodeCity += deliveryAddress.street;
      }
    }
    addressParts.push(postCodeCity);
    return addressParts;
  }
}
